// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"565360d43f387830bf43","351":"c852876437f4ab327475","691":"96d03fc22a75fbf1e416"}[chunkId] + ".js";
};